import { StorageItem } from '@vsolv/packages/storage/domain';

type ThumbFile = Partial<Pick<StorageItem.Model, 'mimeType' | 'downloadUrl' | 'originalFilename'>> | null | undefined;

/** Images get a small preview, served the same way as on the Attachments tab. */
export function fileThumbUrl(file: ThumbFile) {
  return file?.downloadUrl && file.mimeType?.startsWith('image/') ? `${file.downloadUrl}&embedded=true` : null;
}

/** A short type for files without a preview, like PDF; null when there's nothing short to show. */
export function fileTypeLabel(file: ThumbFile) {
  const extension = file?.mimeType === 'application/pdf' ? 'pdf' : file?.originalFilename?.split('.').pop();
  return extension && extension.length <= 4 ? extension.toUpperCase() : null;
}
